import { MapStyle } from 'root/model/map/MapEnums';

export const DETAILED_VIEW_MAP_SCALE_TO_ZOOM = {
    [MapStyle.OS_EXPLORER]: 14,
    [MapStyle.OS_LANDRANGER]: 13,
};
